module.exports = __webpack_public_path__ + "static/img/success.cb2d02e6.png";